import React, { useState } from 'react';
import { Alert, Popover } from '@mui/material';

import './Disclaimer.css';

export const Disclaimer = ({ header, text }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  return (
    <div className="disclaimer-wrapper">
      {/* <a href=''>Logo Disclaimer</a> */}
      <Alert
        severity="info"
        id="alert"
        //aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <p className="disclaimer-header"> {header}</p>
      </Alert>
      <Popover
        id="mouse-over-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <p className="disclaimer-text">{text}</p>
      </Popover>
    </div>
  );
};
